import { render, staticRenderFns } from "./MobileBeer.vue?vue&type=template&id=7748cc70&scoped=true"
import script from "./MobileBeer.vue?vue&type=script&lang=js"
export * from "./MobileBeer.vue?vue&type=script&lang=js"
import style0 from "./MobileBeer.vue?vue&type=style&index=0&id=7748cc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7748cc70",
  null
  
)

export default component.exports